import React, { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import { SelectedPage, NewsItem } from "../../../shared/types";
import news from "../../News/populateNews";
import "./LatestNewsSection.css"; // Import the CSS file for custom styles

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

import Carousel from "react-slick";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
interface ArrowProps {
  onClick?: () => void;
}

type Props = {
  setSelectedPage(value: SelectedPage): void;
};

function LatestNewsSection({ setSelectedPage }: Props) {
  const [selectedNews, setSelectedNews] = useState<NewsItem | null>(null);
  const [coverImage, setCoverImage] = useState<string | null>(null); // State to hold the cover image URL
  const latestNews = news.slice(0, 3);
  const newsItemsRef = useRef<Array<HTMLDivElement | null>>([]);

  const PrevArrow: React.FC<ArrowProps> = ({ onClick }) => (
    <div
      className="absolute top-1/2 left-4 cursor-pointer text-palette1 z-10"
      onClick={() => {
        console.log("Back arrow clicked");
        onClick?.();
      }}
    >
      <FiChevronLeft size={24} />
    </div>
  );

  const NextArrow: React.FC<ArrowProps> = ({ onClick }) => (
    <div
      className="absolute top-1/2 right-4 cursor-pointer text-palette1 z-10"
      onClick={() => {
        console.log("Next arrow clicked");
        onClick?.();
      }}
    >
      <FiChevronRight size={24} />
    </div>
  );

  useEffect(() => {
    const handleScroll = () => {
      newsItemsRef.current.forEach((item, index) => {
        if (item) {
          const rect = item.getBoundingClientRect();
          const isVisible = rect.top < window.innerHeight - 100;

          if (isVisible) {
            item.classList.add("fadeIn");
          }
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Call it once to check initial visibility

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const openNewsPopup = (newsItem: NewsItem) => {
    setSelectedNews((prevNews) => (newsItem === prevNews ? null : newsItem));

    // Set the cover image to the first image in the array of images
    setCoverImage(newsItem.images.length > 0 ? newsItem.images[0] : null);
  };

  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  // ... (previous code)

  const handleImageClick = (image: string) => {
    setSelectedImage(image);
  };

  const closeImagePopup = () => {
    setSelectedImage(null);
  };

  return (
    <div className="bg-gray-100 p-8 mt-8">
      <h2 className="text-3xl lg:text-5xl text-center font-bold text-palette1 mb-6 lg:mb-12">
        Latest News
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {latestNews.map((newsItem: NewsItem, index: number) => (
          <div
            key={index}
            className={`bg-white  rounded-md shadow-md ${
              selectedNews && selectedNews.title === newsItem.title
                ? "col-span-full order-first"
                : ""
            }`}
          >
            <div>
              {newsItem.images &&
                newsItem.images.length > 0 &&
                (selectedNews?.title !== newsItem.title || !selectedNews) && (
                  <img
                    src={newsItem.images[0]}
                    alt={`News ${index + 1}`}
                    className="w-full h-64 object-cover rounded-t-md "
                  />
                )}

              <div
                className="p-6 cursor-pointer"
                onClick={() => openNewsPopup(newsItem)}
              >
                <h3 className="text-xl lg:text-2xl font-bold text-palette1 mb-2">
                  {newsItem.title}
                </h3>
                <p className="text-sm lg:text-base text-palette3 mb-2 font-semibold">
                  {newsItem.date}
                </p>
                <p className="text-sm lg:text-base text-palette1">
                  {newsItem.shortContent == ""
                    ? newsItem.content
                    : newsItem.shortContent}
                </p>
              </div>

              {selectedNews && selectedNews.title === newsItem.title && (
                <div className="px-6 w-full bg-white mb-8  text-justify">
                  <p className="text-sm lg:text-base text-palette1 mb-4">
                    {newsItem.shortContent == "" ? "" : newsItem.content}
                  </p>
                  {selectedNews.images && selectedNews.images.length > 0 && (
                    <Carousel
                      arrows={selectedNews.images.length > 1}
                      prevArrow={<PrevArrow />}
                      nextArrow={<NextArrow />}
                    >
                      {selectedNews.images.map((image, index) => (
                        <img
                          key={index}
                          src={image}
                          alt={image}
                          className="w-auto object-contain h-64 mb-2"
                          onClick={() => handleImageClick(image)}
                        />
                      ))}
                    </Carousel>
                  )}
                  {selectedNews.link && (
                    <div className="text-center my-8">
                      <a
                        href={selectedNews.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-palette3 hover:underline mt-2 inline-block"
                      >
                        Read More
                      </a>
                    </div>
                  )}
                  {selectedNews.dissemination && (
                    <div className="flex flex-col gap-2">
                      <p>{selectedNews.dissemination.text}</p>{" "}
                      {selectedNews.dissemination.urls.map(
                        (dissemination, index) => (
                          <div>
                            <ul className="list-disc lg:px-16 pl-6">
                              <li>
                                <p className="text-palette1 text-justify mt-8">
                                  {dissemination.name}
                                </p>
                                {dissemination.url && (
                                  <a
                                    className="text-palette3 mt-4 hover:underline inline-block"
                                    href={dissemination.url}
                                    target="_new"
                                  >
                                    Read Article
                                  </a>
                                )}
                              </li>
                            </ul>
                          </div>
                        )
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      <NavLink
        to={`/news`}
        onClick={() => {
          setSelectedPage(SelectedPage.News);
        }}
      >
        <div className="flex items-center justify-center mt-4 lg:mt-12">
          <button className="mt-4 bg-palette border border-palette3 text-palette3 px-4 py-2 rounded hover:bg-palette3 hover:text-palette5 transition-colors">
            Discover News
          </button>
        </div>
      </NavLink>

      {/* Modal */}
      {selectedImage && (
        <div
          className="fixed top-0 left-0 w-full h-full bg-palette1 bg-opacity-80 flex items-center justify-center"
          onClick={closeImagePopup}
        >
          <img src={selectedImage} alt="popup" className="h-[calc(70vh)]" />
        </div>
      )}
    </div>
  );
}

export default LatestNewsSection;
